import request from '@/utils/request'

// 分页查询乐谱
export function pageSheet(data) {
  return request({
    url: '/biz/admin/sheet/library/page',
    method: 'post',
    data: data
  })
}

// 乐谱详情
export function getSheet(data) {
  return request({
    url: '/biz/admin/sheet/library/detail',
    method: 'post',
    data: data
  })
}

// 新增乐谱
export function addSheet(data) {
  return request({
    url: '/biz/admin/sheet/library/add',
    method: 'post',
    data: data
  })
}

// 修改乐谱
export function updateSheet(data) {
  return request({
    url: '/biz/admin/sheet/library/edit',
    method: 'post',
    data: data
  })
}

// 删除乐谱
export function delSheet(data) {
  return request({
    url: '/biz/admin/sheet/library/delete',
    method: 'post',
    data: data
  })
}

// 审核乐谱(通过/驳回)
export function auditSheet(data) {
  return request({
    url: '/biz/admin/sheet/library/audit',
    method: 'post',
    data: data
  })
}
